
import Http from "../helpers/Http";

class CashbackDataService {
  
  createCashback(data){
    return Http.post("/customers/cashback",data);
  }

  update(data) {
    return Http.update("/customers/cashback ",data);
  }

  months(){
    return Http.get("/parameters/months");
  }

  getStatus(){
    return Http.get("/status/cashback");
  }

  getCashback(id){
    return Http.get(`/customers/cashback/${id}`)
  }

}

export default new CashbackDataService();